import { render } from "./ListDonasiView.vue?vue&type=template&id=87496aaa"
import script from "./ListDonasiView.vue?vue&type=script&lang=js"
export * from "./ListDonasiView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__